module.exports = __webpack_public_path__ + "img/智慧工地2.c598ab2a.png";